<script lang="ts">
	import type { Device } from 'src/types/Device';
	import RelayPriorityView from 'src/components/Sidepanel/DeviceViews/Relay/RelayPriorityView.svelte';

	export let device: Device;
</script>

<RelayPriorityView {device} />
